const common = {
  PleaseEnter: ["请输入", "Please Enter "],
  AccountID: ["账号", "AccountID"],
  Password: ["密码", "Password"],
  PasswordSpace: ["密码", "Password"],
  VCode: ["验证码", "VCode"],
  Language: ["语言", "Language"],
  Mobile: ["手机号", "Mobile"],
  Email: ["邮箱", "Email"],
  PrivacyPolicy: ["隐私协议", "Privacy Policy"],
  Login: ["登录", "Login"],
  Divider: ["/", "/"],
  TheRight: ["正确的", "The Right "],
  Space: ["", " "],
  GetCode: ["获取验证码", "Get VCode"],
  Resend: ["重新发送", "Resend"],
  After: ["后", "After"],
  OwlCloud: ["翱泰", "OwlTrust"],
  Loading: ["加载中", "Loading"],
  NoMore: ["没有更多了", "No More"],
  Enter: ["进入", "Enter"],
  Copies: ["文件数", "Copies"],
  Home: ["首页", "Home"],
  Upload: ["上传", "Upload"],
  Attachment: ["附件", "Attachment"],
  File: ["文件", "File"],
  Select: ["选择", "Select"],
  Remark: ["备注", "Remark"],
  Action: ["操作", "Action"],
  Details: ["查看详情", "Details"],
  Edit: ["编辑", "Edit"],
  Add: ["添加", "Add"],
  Send: ["发送", "Send"],
  Delete: ["删除", "Delete"],
  Download: ["下载", "Download"],
  Tips: ["提示", "Tips"],
  AreYouSure: ["您确定要", "Are you sure to "],
  Confirm: ["确定", "Confirm"],
  Cancel: ["取消", "Cancel"],
  Name: ["姓名", "Name"],
  NotVerified: ["未认证", "not Verified"],
  Verified: ["已认证", "Verified"],
  Wechat: ["微信", "Wechat"],
  Binding: ["绑定", "Binding"],
  Status: ["状态", "Status"],
  Save: ["保存", "Save"],
  PlusCode: [" + ", " + "],
  None: ["无", "None"],
  Choose: ["选择", "Choose"],
  Back: ["返回", "Back"],
  Clear: ["清空", "Clear"],
  Warn: ["警告", "warn"],
  Warning: ["警告", "Warning"],
};

export default common;
